module.exports = __webpack_public_path__ + "static/media/growing-new-farmers.f4245811.jpg";